
export class Payement {
  //event
  public id:number;
  public domiciliation:string;
  public Titulaire:  string;
  public iban: string;
  public bic: string;
  public site: string;
  public rib_iban_pdf:any;
  public user_id: number;
  public validatedByAdmin: boolean = false;
  public devise:string='selectionnez';
  constructor() {}
}
